export enum FreeTrialStatus {
    Active,
    Available,
    Expired
}